import React, { PureComponent } from "react";
import { AccountCardComponent } from "../CardComponent/CardComponent";
import { Row, Icon } from "antd";
import close from "../../../../../assets/icons/close.svg";
import "./pendingAlert.css";

export default class TiffAlert extends PureComponent {
  state = {
    Alert_status: true,
    maintenanceAlert: ""
  };

  componentWillMount() {
    this.setState({
      tiffAlert: this.props.account_data.tiffAlert
    });
  }

  closeAlert = () => {
    this.setState({
      Alert_status: false
    });
  };
  render() {
    return (
      <div>
        {!this.state.tiffAlert ? (
          ""
        ) : (
          <div className="pending-alert-container">
            <Row>
              <div>
                <AccountCardComponent
                  className={
                    this.state.Alert_status === true ? "open" : "close"
                  }
                >
                  <div>
                    <Icon type="warning" style={{ display: "inline-block" }} />
                    <p className="desktop">
                      Your account is currently invested{" "}
                      {this.props.account_data.tiffPercentage}% in TIFF. As a
                      reminder VC imposes a 90% limit. You are not required to
                      take any action, but action may be needed in the future to
                      process any necessary transactions on your account.
                    </p>
                    <p className="mobile">
                      Your account is currently invested{" "}
                      {this.props.account_data.tiffPercentage}% in TIFF. As a
                      reminder VC imposes a 90% limit. You are not required to
                      take any action, but action may be needed in the future to
                      process any necessary transactions on your account.
                    </p>
                  </div>
                  <img
                    src={close}
                    style={{ margin: "auto 5px" }}
                    onClick={this.closeAlert}
                    className="mr-icon"
                    alt="close icon"
                  />
                </AccountCardComponent>
              </div>
            </Row>
          </div>
        )}
      </div>
    );
  }
}
